import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import PriceButton, {
  type SpendableCurrency,
} from 'src/components/Wallet/PriceButton';

type Props = {
  price: number;
  currency?: SpendableCurrency;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  label?: string;
  size?: 'middle' | 'large';
  'data-testid': string;
};
export type { Props as RechargeFreezeButtonProps };

const RechargeFreezeButton: FunctionComponent<Props> = ({
  price,
  currency = 'BABZ',
  onClick,
  disabled,
  loading,
  label,
  size = 'large',
  'data-testid': dataTestId,
}) => {
  const { t } = useTranslation();

  return (
    <PriceButton
      cost={price}
      currency={currency}
      size={size}
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      data-testid={dataTestId}
      className="w-full bg-streak-freeze-button border-textBlue shadow-textBlue text-structural-darkest"
      pillClassName="bg-textBlue"
    >
      {label ?? t('streak.freeze.recharge')}
    </PriceButton>
  );
};

export default RechargeFreezeButton;
